module.exports = __webpack_public_path__ + "static/img/b8.f897b2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/b8.png
// module id = vOga
// module chunks = 1